var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGift({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 2.667a4.667 4.667 0 0 1 4.217 6.668L28 9.333a1.333 1.333 0 0 1 1.333 1.334V16a1.333 1.333 0 0 1-1.334 1.333h-1.333V28a1.333 1.333 0 0 1-1.333 1.333H6.666A1.333 1.333 0 0 1 5.333 28V17.333H3.999A1.333 1.333 0 0 1 2.666 16v-5.333a1.333 1.333 0 0 1 1.333-1.334l4.45.002A4.667 4.667 0 0 1 16 4.068a4.64 4.64 0 0 1 3.332-1.401zm4.666 14.666H8v9.334h16v-9.334zM26.666 12H5.333v2.667h21.333V12zm-14-6.667a2 2 0 0 0-.192 3.991l.192.01h2v-2a2 2 0 0 0-1.808-1.991l-.192-.01zm6.667 0-.192.01a2 2 0 0 0-1.8 1.798l-.008.192v2h2l.192-.009a2 2 0 0 0 0-3.981l-.192-.01z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGift);
export default __webpack_public_path__ + "static/media/ic-gift.491b633b0e016f2cad682856ed721857.svg";
export { ForwardRef as ReactComponent };